import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import i18n from '@/i18n/i18n'

const initialState = () => {
  return {
    module: 'typeevents',
    model: 'typeEvent',
    loading: false,
    selected: {
      name: [],
      icon: '',
      type: [],
      vote: false,
    },
    filters: {},
    list: [],
    selectList: [],
    typeEventsConst: {},
    types: ['official', 'user', 'training'],
    groups: [
      'offensivePhase',
      'defensivePhase',
      'transitionAD',
      'transitionDA',
      'setTopAction',
      'physicalPreparation',
      'technique',
      'tacticalTechnician',
      'collectiveTactics',
      'appliedMatches',
      'strategy',
      'arbitration',
      'player',
      'free',
    ],
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  types(state) {
    return state.types.map((item) => ({
      value: item,
      text: i18n.t(`fields.events.types.${item}`),
    }))
  },
  groups(state) {
    return state.groups.map((item) => ({
      value: item,
      text: i18n.t(`fields.events.groups.${item}`),
    }))
  },
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      createdAt: formatDate(item.createdAt, true),
    }))
  },
}

const actions = {
  ...baseActions,
  async fetchList({ commit, state }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async fetchListConst({ commit, state }) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/constants')
      .finally(() => commit('setLoading', false))

    const typeEventsConst = data.data ? data.data.typeEvents : {}
    commit('setTypeEventsConst', typeEventsConst)
  },
}

const mutations = {
  ...baseMutations,
  setTypeEventsConst(state, payload) {
    state.typeEventsConst = payload || {}
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
